import {
  Business as BusinessIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import React from 'react';

import EnrollmentBadge from '../EnrollmentBadge';

export interface BusinessInfo {
  identifier: string;
  isEnrolled?: boolean;
  businessName?: string;
  id?: string;
  onChangeClient: () => void;
  editable?: boolean;
}

const ClientInfo: React.FC<BusinessInfo> = ({
  identifier,
  businessName,
  isEnrolled,
  onChangeClient,
  editable = true,
}) => {
  if (!identifier) return null;

  return (
    <Paper
      sx={{
        p: '12px',
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        position: 'relative',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ width: '100%' }}
      >
        <Box
          sx={{
            backgroundColor: 'primary.main',
            borderRadius: '50%',
            p: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <BusinessIcon sx={{ fontSize: '1rem' }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          {businessName ? (
            <>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: '1rem',
                    lineHeight: 1.1,
                  }}
                >
                  <strong>Empresa:</strong> {businessName}
                </Typography>
                {editable && (
                  <LightTooltip
                    title={<Typography padding={1}>Cambiar</Typography>}
                    placement="top"
                  >
                    <IconButton
                      size="small"
                      onClick={onChangeClient}
                      sx={{ p: 0.5 }}
                      color="primary"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </LightTooltip>
                )}
              </Stack>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                <strong>RUT:</strong> {identifier}
              </Typography>
            </>
          ) : (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                fontSize: '1rem',
                lineHeight: 1.1,
              }}
            >
              <strong>RUT:</strong> {identifier}
            </Typography>
          )}
        </Box>
        {isEnrolled !== undefined && (
          <Box sx={{ ml: 2 }}>
            <EnrollmentBadge isEnrolled={isEnrolled} />
          </Box>
        )}
      </Stack>
    </Paper>
  );
};

export default ClientInfo;
